import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Full-page loading gate — shown while a page's top-level data is still
// being fetched, so no tab/list ever flashes empty or stale content before
// the real data arrives. Reuses the same pulsing-ring/wave-bar animation
// language established for the Client Card loader (styles.css, arcdxLoader*).
const LoadingGate = ({ icon: Icon, message = "Loading…" }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        background: "linear-gradient(155deg, #eaf4ff 0%, #f6f8fb 55%, #eef2ff 100%)",
        backgroundImage: "radial-gradient(rgba(21,101,192,0.07) 1.5px, transparent 1.5px), linear-gradient(155deg, #eaf4ff 0%, #f6f8fb 55%, #eef2ff 100%)",
        backgroundSize: "26px 26px, cover",
        animation: "arcdxLoaderDrift 6s linear infinite",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "26px",
      }}
    >
      <Box sx={{ position: "relative", width: 110, height: 110, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Box sx={{ position: "absolute", inset: 0, borderRadius: "50%", border: "3px solid #1565C0", animation: "arcdxLoaderPulseRing 2s ease-out infinite" }} />
        <Box sx={{ position: "absolute", inset: 0, borderRadius: "50%", border: "3px solid #4db2fc", animation: "arcdxLoaderPulseRing 2s ease-out infinite 0.7s" }} />
        <Box sx={{ position: "absolute", inset: 0, borderRadius: "50%", border: "3px solid #7c9bff", animation: "arcdxLoaderPulseRing 2s ease-out infinite 1.4s" }} />
        <Box
          sx={{
            width: 68,
            height: 68,
            borderRadius: "26px",
            background: "linear-gradient(155deg, #4db2fc 0%, #1565C0 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 14px 30px rgba(21,101,192,0.4)",
            animation: "arcdxLoaderFloat 2.2s ease-in-out infinite",
          }}
        >
          {Icon && <Icon sx={{ fontSize: 32, color: "#fff" }} />}
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "flex-end", gap: "7px", height: 32 }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              width: 7,
              borderRadius: "5px",
              background: "linear-gradient(180deg, #4db2fc, #1565C0)",
              animation: "arcdxLoaderWaveBar 1s ease-in-out infinite",
              animationDelay: `${i * 0.12}s`,
            }}
          />
        ))}
      </Box>

      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 800,
          fontFamily: "Roboto, Arial, sans-serif",
          letterSpacing: "0.02em",
          backgroundImage: "linear-gradient(90deg, #7c9bff 0%, #1565C0 25%, #4db2fc 50%, #1565C0 75%, #7c9bff 100%)",
          backgroundSize: "200% auto",
          color: "transparent",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          animation: "arcdxLoaderShimmer 2.4s linear infinite",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingGate;
